import { ColumnLayout, defineComponent, inferProps, renderSlot, type ReactiveComponent } from "vue-utils"
import BootstrapButton from "../BootstrapButton"

interface Props {
	confirmText: string
	cancelText: string
	onCancel: () => void
	onSubmit: () => void
}

const ConfirmForm: ReactiveComponent<Props> = (props, { slots }) => {
	return () => (
		<form
			onSubmit={(e) => {
				e.preventDefault()
				props.onSubmit()
			}}
		>
			{renderSlot(slots)}
			<hr class="w-100" />
			<div class="d-flex justify-content-end">
				<ColumnLayout spacing="1rem" columns={2}>
					<BootstrapButton color="secondary" onClick={props.onCancel}>
						{props.cancelText}
					</BootstrapButton>
					<BootstrapButton color="decider" type="submit">
						{props.confirmText}
					</BootstrapButton>
				</ColumnLayout>
			</div>
		</form>
	)
}

export default defineComponent(ConfirmForm, inferProps<Props>())
